import ITA_MUNICIPALITIES from './ita_municipalities.json';
import ITA_COUNTRIES from './ita_countries.json';
import countries from './countries.json';
import ITA_PROVINCES from './itaProvinces.json';
export default {
  PAYMENT_TYPE: ['EFECT', 'TARJT', 'TRANS', 'PLATF', 'MOVIL', 'TREG', 'DESTI', 'OTRO'],
  RESERVATION_STATUS_TYPE: ['A', 'B'],
  ROLE_TYPE: ['TI', 'VI'],
  CONTACT_TYPE: ['email', 'telefono'],
  CONTACT_TYPE_RH: ['email', 'telefono', 'empty'], // For RH, 'empty' resets contact info
  DOCUMENT_TYPE: [
    'empty',
    'dni',
    'passport',
    'idCard',
    'residencePermit',
    'drivingLicence',
    'other',
  ],
  MUNICIPALITIES: require('./municipalities.json'),
  FAMILY_RELATIONSHIP: require('./relationship.json'),
  COUNTRIES: require('./countries.json'),
  ADULT_AGE: 14,
  API_DATE_FORMAT: 'YYYY-MM-DD',
  POLICE_REPORT_SCHEDULE_TYPE: 'pre-stay-police-report-notify-report-error',

  // Italia standards
  // Tipo Alloggiato: 16 OSPITE SINGOLO, 17 CAPO FAMIGLIA, 18 CAPO GRUPPO, 19 FAMILIARE, 20 MEMBRO GRUPPO
  ITALIAN_ROLE_TYPE: [
    'OSPITE SINGOLO',
    'CAPO FAMIGLIA',
    'CAPO GRUPPO',
    'FAMILIARE',
    'MEMBRO GRUPPO',
  ],
  // 1 (M), 2 (F)
  ITA_GENDERS: ['M', 'F'],
  ITA_DOCUMENT_TYPE: ['IDENT', 'PASOR', 'IDELE', 'PATEN', 'RIFUG', 'PASSE', 'PASDI', 'OTHER'],
  ITA_MUNICIPALITIES: ITA_MUNICIPALITIES,
  ITA_PROVINCES: ITA_PROVINCES,
  ITA_COUNTRIES: countries,
  ITA_ADULT_AGE: 14,
  ITA_MAX_STAY_DAYS: 30,
  ITA_DATE_FORMAT: 'DD/MM/YYYY',

  ITA_API_DATE_FORMAT: 'YYYY-MM-DD',
};
